import React, { useEffect, useState } from "react";

function Hero() {
  const [message, setMessage] = useState<string>("bg-heroiv"); // Initial state
  const messages = ["bg-hero", "bg-heroii", "bg-heroiii", "bg-heroiv"];
  const [lastScrollY, setLastScrollY] = useState(0);
  const [show, setShow] = useState(false);
  const controlNavbar = () => {
    if (window.scrollY > 880) {
      // if scroll down hide the navbar
      setShow(true);
    } else if (window.scrollY <= 800) {
      // if scroll up show the navbar
      setShow(false);
    }
    // remember current page location to use in the next move
    setLastScrollY(window.scrollY);
  };
  useEffect(() => {
    let currentIndex = 0;
    const intervalId = setInterval(() => {
      setMessage(messages[currentIndex]);
      currentIndex = (currentIndex + 1) % messages.length;
    }, 5000);

    return () => clearInterval(intervalId);
  }, [messages]);

  useEffect(() => {
    window.addEventListener("scroll", controlNavbar);
    return () => {
      window.removeEventListener("scroll", controlNavbar);
    };
  }, [lastScrollY]);
  const scrollTo = () => {
    window.scrollTo(0, 900);
  };

  return (
    <div
      className={`${message} ${
        message === "bg-hero" && "!bg-right"
      } bg-cover bg-black bg-center md:bg-top flex justify-end items-end z-30 fixed top-0 w-full h-screen ${
        show && "opacity-0"
      }`}
    >
      <div className="bg-transparent px-24 py-36 flex flex-col justify-center gap-4 text-center h-full w-full absolute z-30">
        <p className="text-white heading">
          Love Your Skin, <span className="italic">Naturally</span>.
        </p>
        <p className="text-white/80 sub-heading">
          Glow from the inside out with skincare that’s as unique as you are.
        </p>
        <div className="flex flex-col justify-center items-center gap-4">
          <button className="capitalize text-white font-semibold py-3 px-10 hover:text-primary hover:bg-white bg-primary mt-4">
            Shop now
          </button>
          {/* <span className="text-white/80">or</span> */}
        </div>
        <div className="w-full left-0 absolute bottom-10 grid place-items-center">
          <button className="flex items-center justify-center relative w-max hover:bg-primary group bg-white/60 ring-1 hover:ring-primary ring-white rounded-full text-xs font-semibold py-2 px-4 hover:text-white text-primary">
            Find your perfect routine
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 16"
              fill="white"
              className="size-4 hidden group-hover:block"
            >
              <path
                fillRule="evenodd"
                d="M4.22 11.78a.75.75 0 0 1 0-1.06L9.44 5.5H5.75a.75.75 0 0 1 0-1.5h5.5a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0V6.56l-5.22 5.22a.75.75 0 0 1-1.06 0Z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        </div>
      </div>

      <div
        onClick={scrollTo}
        className="relative z-30 p-2 txt flex items-center flex-col mb-10 text-white mr-10 cursor-pointer gap-1 hover:gap-1.5"
      >
        <p>S</p>
        <p>H</p>
        <p>O</p>
        <p>P</p>
        <p></p>
        <p>N</p>
        <p>O</p>
        <p>W</p>
        <img src={require("../images/arrow.png")} alt="" className="mt-3 img" />
      </div>
      <div className="bg-black/20 absolute top-0 h-screen w-full"></div>
    </div>
  );
}

export default Hero;
